import React from "react";
import "./FloorPlan.less";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
  uploadSpsAPiRequest,
  getSpsAPiRequest,
  apiRequest,
  spsApiPost,
  uploadSpsMetadataAPiRequest
} from "../../../../utils/api_service";
import { ShowToast, toastType } from "../../../../utils/toast-service";
import { getSharepointUrl } from "../../../../utils/sharePointService";
import { API_URL } from "../../../../constants/api";
import {
  setSPSToken,
  SPSToken,
  SECTIONS
} from "../../../../constants/appConstants";
import moment from "moment";
import { GetSectionPermission } from "../../../../utils/helper";
class FloorPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ActiveView: "ShowPlan",
      fileSetting: undefined,
      selectedFile: [],
      checkedItems: new Map()
    };
  }

  componentWillMount() {
    fetch("/public/config/fileuploadsettings.json")
      .then(res => res.json())
      .then(data => {
        this.setState({ fileSetting: data });
      });
    apiRequest({ url: API_URL.getSPSToken }).then(({ data }) => {
      setSPSToken(data);
    });
    this.getSpsData(localStorage.getItem("selectedPropertyId"));
  }

  componentWillReceiveProps(newProps) {
    if (newProps.propertyId !== this.props.propertyId) {
      this.getSpsData(localStorage.getItem("selectedPropertyId"));
    }
  }

  optionData = [{ key: 1, label: "Keep Both" }, { key: 2, label: "Replace" }];

  /** get data from sharepoint */
  getSpsData = () => {
    const propertyId = localStorage.getItem("selectedPropertyId");
    if (SPSToken) {
      getSpsAPiRequest(getSharepointUrl("getSps", propertyId)).then(
        spsDataRes => {
          if (spsDataRes.status === 404) {
            const url = getSharepointUrl("createDrive");
            const apiBody = {
              displayName: propertyId,
              columns: [
                {
                  name: "FileType",
                  text: {}
                },
                {
                  name: "UserEmail",
                  text: {}
                }
              ],
              list: {
                template: "documentLibrary"
              }
            };
            spsApiPost({ url: url, postBody: apiBody }).then(data => {
              this.setCategoryWiseData(data);
            });
          } else {
            this.setCategoryWiseData(spsDataRes);
          }
        }
      );
    } else {
      apiRequest({ url: API_URL.getSPSToken }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
          this.getSpsData(propertyId);
        }
      });
    }
  };

  /** Set category wise data */
  setCategoryWiseData = spsDataRes => {
    if (!spsDataRes) return;
    const { value } = spsDataRes;
    this.setState({ spsAllData: spsDataRes });
    const spsCategories = {
      colorBook: [],
      siteplan: [],
      actualImages: [],
      otherDocs: []
    };
    const categoriesKeysList = Object.keys(spsCategories);
    value &&
      value.forEach(obj => {
        const catKeyByName =
          categoriesKeysList.indexOf(obj.name.split("_")[0]) !== -1
            ? obj.name.split("_")[0]
            : "";
        const caseKey =
          (obj.listItem.fields.FileType || "").toLowerCase() || catKeyByName;
        switch (caseKey) {
          case "siteplan":
            spsCategories[caseKey].push(obj);
            break;
          case "colorBook":
            spsCategories[caseKey].push(obj);
            break;
          case "actualImages":
            spsCategories[caseKey].push(obj);
            break;
          default:
            spsCategories["otherDocs"].push(obj);
            break;
        }
      });
    this.setState({ spsData: spsCategories });
  };

  /** validation of file */
  validateFile(fileObj) {
    const { fileSetting } = this.state;
    let flag = false;
    let errorMsg = "";
    const curFileExt = fileObj.name
      .substring(fileObj.name.lastIndexOf("."))
      .toLowerCase();
    if (
      fileSetting.AllowedExtensionsByCategory["siteplan"]
        .split(",")
        .indexOf(curFileExt) < 0
    ) {
      errorMsg = curFileExt + " type files not allowed";
    } else if (fileObj.size > fileSetting.MaxFileSize) {
      errorMsg = fileSetting.FileSizeErrorMsg;
    } else {
      flag = true;
    }

    const isFieExist = this.isFileExists(fileObj.name);
    const canUpload = !flag ? flag : flag && !isFieExist;
    const value = {
      fileData: fileObj,
      isFileExist: isFieExist,
      message: errorMsg,
      isFileReplace: true,
      isValid: flag,
      canUpload: canUpload,
      fileAction: 0
    }; // [...this.state.selectedFile, { "IsValid": flag, "Message": errorMsg, fileData: fileObj }]

    this.setState(prevState => ({
      selectedFile: prevState.selectedFile.concat(value)
    }));

    return flag;
  }

  /** call on file change */
  onFileChange = event => {
    this.setState({ selectedFile: [], checkedItems: new Map() });
    if (event.target && !event.target.files.length) return;
    Array.from(event.target.files).map(file => {
      this.validateFile(file);
    });

    setTimeout(() => {
      const filesToUpload = this.state.selectedFile.filter(item => {
        return item.canUpload;
      });

      if (filesToUpload.length == this.state.selectedFile.length) {
        this.onFileUpload();
      } else {
        ShowToast(
          "File type not supported. Allowed types are .png, .jpg, .jpeg",
          toastType.ERROR,
          5000,
          200
        );
      }
    }, 3);

    event.target.value = "";
  };

  /** get list */
  getList = (fileName, emailId) => {
    getSpsAPiRequest(
      getSharepointUrl("getSps", localStorage.getItem("selectedPropertyId"))
    ).then(spsDataRes => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.updateMetaData(value[i].listItem.id, emailId);
            break;
          }
        }
      }
    });
  };

  /** update meta data information */
  updateMetaData = (itemId, emailId = "") => {
    const metadata = {
      FileType: this.props.selectedCategory,
      UserEmail: emailId
    };
    uploadSpsMetadataAPiRequest(
      getSharepointUrl(
        "uploadMetadata",
        localStorage.getItem("selectedPropertyId"),
        itemId
      ),
      metadata
    ).then(() => {
      this.setState({ selectedFile: [] });
      this.getSpsData();
    });
  };

  /** call on remove file */
  removeFile = index => {
    const { selectedFile } = this.state;
    const list = [...selectedFile];
    list.splice(index, 1);
    this.setState({ selectedFile: list });
    if (list.length == 0) {
      this.closeModal();
    }
  };

  /** check for file existance */
  isFileExists(filename) {
    if (this.state.spsAllData.value) {
      return (
        this.state.spsAllData.value.filter(data => {
          return data.name == filename;
        }).length > 0
      );
    }
    return false;
  }

  /** calll on file upload */
  onFileUpload = () => {
    //this.closeModal();
    const userPref = localStorage.getItem("userPreference");
    const emailId = userPref ? JSON.parse(userPref).emailId : "";

    const filesToUpload = this.state.selectedFile.filter(item => {
      return item.canUpload;
    });

    if (filesToUpload.length > 0) {
      for (let index = 0; index < filesToUpload.length; index++) {
        const re = /(?:\.([^.]+))?$/;
        const ext = re.exec(filesToUpload[index].fileData.name)[1];
        const allowedExt = ["png", "jpg", "jpeg"];
        if (allowedExt.find(x => x == ext.toLowerCase()) != undefined) {
          spsApiPost({
            url: getSharepointUrl(
              "uploadFileSession",
              localStorage.getItem("selectedPropertyId"),
              "sitePlan_" +
                localStorage.getItem("selectedPropertyId") +
                "." +
                ext
            ),
            postBody: {
              fileSize: filesToUpload[index].fileData.size,
              item: {
                "@microsoft.graph.conflictBehavior": "replace"
              }
            }
          }).then(data => {
            if (data) {
              uploadSpsAPiRequest(
                data.data.uploadUrl,
                filesToUpload[index].fileData,
                this.state.checkedItems,
                true
              ).then(data => {
                if (data) {
                  ShowToast(
                    "File uploaded successfully.",
                    toastType.SUCCESS,
                    5000,
                    200
                  );
                  this.getList(data.name, emailId);
                  this.getSpsData();
                  this.setState({ ActiveView: "ShowPlan" });
                } else {
                  ShowToast("File not uploaded successfully.", toastType.ERROR);
                }
              });
            }
          });
        } else {
          ShowToast(
            "File type not supported. Allowed types are .png, .jpg, .jpeg",
            toastType.ERROR,
            5000,
            200
          );
        }
      }
    }
  };

  /** Update enable desable check */
  isUploadDisable = () => {
    try {
      let validFileCnt = 0;
      let canUploadFileCnt = 0;
      this.state.selectedFile.map(item => {
        if (item.isValid) validFileCnt++;
        if (item.canUpload) canUploadFileCnt++;
      });
      return !(validFileCnt == canUploadFileCnt && validFileCnt > 0);
    } catch (e) {
      return true;
    }
  };

  render() {
    const { fileSetting, spsData } = this.state;
    const permission = GetSectionPermission(
      SECTIONS.SITE_PROFILE,
      SECTIONS.SITE_PLAN
    );
    const IsEditable = permission.accessTypeId > 1 ? true : false;

    return (
      <Grid container className={"floor-plan-container"}>
        <Grid item xs={12} md={12}>
          {IsEditable && (
            <Box className={"icon-bar"}>
              {this.state.ActiveView == "ShowPlan" ? (
                <Tooltip title={"Upload New Site Plan"} placement={"top"}>
                  <IconButton
                    style={{ marginRight: "10px" }}
                    onClick={() => this.setState({ ActiveView: "UploadPlan" })}
                    size={"medium"}
                  >
                    <CloudUploadIcon fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={"View Site Plan"} placement={"top"}>
                  <IconButton
                    style={{ marginRight: "10px" }}
                    onClick={() => this.setState({ ActiveView: "ShowPlan" })}
                    size={"medium"}
                  >
                    <VisibilityIcon fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )}
        </Grid>
        {this.state.ActiveView == "UploadPlan" && IsEditable ? (
          <Grid item xs={12} md={12}>
            <Box className={"upload-area"}>
              <div className={"upload-div"}>
                <input
                  id={"contained-button-file"}
                  type={"file"}
                  onChange={this.onFileChange}
                  accept={
                    fileSetting &&
                    fileSetting.AllowedExtensionsByCategory["siteplan"]
                  }
                />
                <br />
                <label>
                  {/* <Button variant="contained" color="primary" component="span">
                    Upload
                  </Button> */}
                </label>
              </div>
            </Box>
          </Grid>
        ) : (
          <Grid item xs={12} md={12}>
            <Grid container>
              {/* <Grid item xs={12} md={3}>
                <Box>List</Box>
              </Grid> */}
              <Grid item xs={12} md={12}>
                <Box>
                  {spsData &&
                  spsData.siteplan.sort(
                    (a, b) =>
                      moment(a.lastModifiedDateTime) -
                      moment(b.lastModifiedDateTime)
                  )[spsData.siteplan.length - 1] ? (
                    <div className={"floor-plan-wrapper"}>
                      <img
                        src={
                          spsData.siteplan[spsData.siteplan.length - 1][
                            "@microsoft.graph.downloadUrl"
                          ]
                        }
                        alt={"logo"}
                        className={"floor-plan"}
                      />
                    </div>
                  ) : (
                    <div className={"no-plan-message"}>
                      {"No Site plan available."}{" "}
                      {IsEditable &&
                        "Click upload button on top right to upload site plan."}
                    </div>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  }
}

export default FloorPlan;
